import React from 'react'
import styled from 'styled-components'
import { BackgroundSection } from 'fbk-components'
import { Sharing } from 'components'
import * as Icons from 'assets/svg'
import { spacings, width } from 'theme'

const Wrapper = styled(BackgroundSection)`
  background: ${({ theme }) => theme.colors.greyBg};

  > div {
    padding-top: 30px;
    padding-bottom: 30px;
    ${width('contentWidth')}
  }
`

const StyledSharing = styled(Sharing)`
  margin-top: 20px;

  li {
    :not(:last-child) {
      ${spacings('margin-right', 'xs')}
    }

    a {
      color: ${({ theme }) => theme.colors.grey};
    }

    :hover a {
      color: #000;
    }
  }
`

const SharingSection = () => {
  return (
    <Wrapper>
      <div className="sharing-wrap">
        <p className="g-big-text">Поделиться в соцсетях</p>
        <StyledSharing
          socials={[
            { type: 'telegram', IconComponent: Icons.Telegram },
            { type: 'twitter', IconComponent: Icons.Twitter },
            { type: 'vk', IconComponent: Icons.Vk },
            { type: 'facebook', IconComponent: Icons.Facebook },
            { type: 'ok', IconComponent: Icons.Ok },
          ]}
        />
      </div>
    </Wrapper>
  )
}

export default SharingSection
